import * as React from 'react';

import classnames from 'classnames';

import {MarketingTitle} from 'shells/typography/marketing-title';

import type {CalendarSync as CalendarSyncFragment} from 'nutshell-graphql-types';

import {CalendarContactCreationRuleRadioGroup} from './calendar-contact-creation-rule-radio-group';
import {CalendarExportRuleRadioGroup} from './calendar-export-rule-radio-group';
import {CalendarImportRadioGroup} from './calendar-import-radio-group';
import {serviceNameMap} from './calendar-options';
import {ChangeCurrentCalendar} from './change-current-calendar';
import {getExportIcon, getImportIcon} from './helpers';

import styles from './calendar-options.module.css';

type Props = {
    calendarSync: CalendarSyncFragment;
    isDisabled: boolean;
    hideIllustrations?: boolean;
    hideSelectCalendar?: boolean;
};

export function CalendarOptionsRadioGroups(props: Props) {
    const serviceName = serviceNameMap[props.calendarSync.externalService];
    const selectedCalendar = props.calendarSync.calendars.find(
        (calendar) => calendar.syncType === 'PRIMARY'
    );

    const disabledOverlayClass = classnames({
        [styles['disabled-overlay']]: !props.calendarSync.isEnabled,
        [styles['disabled-overlay--no-selected-calendar']]:
            !selectedCalendar && props.calendarSync.isEnabled,
    });

    const importIcon = getImportIcon(props.calendarSync.externalService);

    return (
        <>
            {props.isDisabled ? <div className={disabledOverlayClass} /> : null}
            {!props.hideSelectCalendar && (
                <>
                    <MarketingTitle>Which calendar would you like to use?</MarketingTitle>
                    <div className={styles['setting-section']}>
                        <ChangeCurrentCalendar calendarSync={props.calendarSync} />
                    </div>
                </>
            )}
            <MarketingTitle>
                Which activities should we add to your {serviceName} calendar?
            </MarketingTitle>
            <div className={classnames('flex justify-sb', styles['setting-section'])}>
                <CalendarExportRuleRadioGroup
                    calendar={selectedCalendar}
                    // @ts-expect-error
                    serviceName={serviceName}
                    disabled={props.isDisabled}
                />
                {!props.hideIllustrations && (
                    <div className={styles['illustration-container']}>
                        {getExportIcon(props.calendarSync.externalService)}
                    </div>
                )}
            </div>
            <MarketingTitle>
                Would you like to import events from your {serviceName} calendar?
            </MarketingTitle>
            <div className={classnames('flex justify-sb', styles['setting-section'])}>
                <CalendarImportRadioGroup
                    calendarSync={props.calendarSync}
                    disabled={props.isDisabled}
                />
                {!props.hideIllustrations && (
                    <div className={styles['illustration-container']}>{importIcon}</div>
                )}
            </div>
            {NutClientConfig.hasActivitySyncContactCreationFF && (
                <>
                    <MarketingTitle>
                        Would you like to create people from imported activities?
                    </MarketingTitle>
                    <div className={classnames('flex justify-sb', styles['setting-section'])}>
                        <CalendarContactCreationRuleRadioGroup
                            calendar={selectedCalendar}
                            disabled={props.isDisabled || !props.calendarSync.importIsEnabled}
                            toolTip={
                                !props.calendarSync.importIsEnabled
                                    ? 'Event importing must be enabled'
                                    : undefined
                            }
                        />
                        {!props.hideIllustrations && (
                            <div className={styles['illustration-container']}>{importIcon}</div>
                        )}
                    </div>
                </>
            )}
        </>
    );
}
